var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3296 11.2977H14.8242C14.375 11.2977 14.011 11.6617 14.011 12.1108V21.8691C14.011 22.3181 14.375 22.6823 14.8242 22.6823H21.3296C21.7787 22.6823 22.1428 22.3181 22.1428 21.8691V12.1108C22.1428 11.6617 21.7787 11.2977 21.3296 11.2977Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3296 1.53943H14.8242C14.375 1.53943 14.011 1.9035 14.011 2.35261V5.62162C14.011 6.07073 14.375 6.43481 14.8242 6.43481H21.3296C21.7787 6.43481 22.1428 6.07073 22.1428 5.62162V2.35261C22.1428 1.9035 21.7787 1.53943 21.3296 1.53943Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31867 1.53943H1.81319C1.36408 1.53943 1 1.9035 1 2.35261V12.1108C1 12.5599 1.36408 12.924 1.81319 12.924H8.31867C8.76778 12.924 9.13186 12.5599 9.13186 12.1108V2.35261C9.13186 1.9035 8.76778 1.53943 8.31867 1.53943Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31867 17.7869H1.81319C1.36408 17.7869 1 18.1509 1 18.6001V21.8691C1 22.3181 1.36408 22.6823 1.81319 22.6823H8.31867C8.76778 22.6823 9.13186 22.3181 9.13186 21.8691V18.6001C9.13186 18.1509 8.76778 17.7869 8.31867 17.7869Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon2);
export default __webpack_public_path__ + "static/media/menuIcon2.02216d405615e379ce069f80068023f9.svg";
export { ForwardRef as ReactComponent };